import script from "./ClassificationTree.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassificationTree.vue?vue&type=script&setup=true&lang=js"

import "./ClassificationTree.vue?vue&type=style&index=0&id=26993287&lang=scss"

export default script